import Router from "./router/Router.js";

function App() {
  return <Router />;
}
export default App;
